import axios from "../../axios";

const checkAllProxies = async function (accessToken) {
    try {
        const response = await axios.post('proxy/checkAllProxies', {}, {
            headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response?.status || 500,
            message: e.response?.data?.message || 'Có lỗi xảy ra'
        }
    }
}

export default checkAllProxies;
